<router-outlet></router-outlet>
<p-confirmDialog></p-confirmDialog>
<p-toast></p-toast>
<app-global-loader></app-global-loader>